var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"},on:{"touchstart":function($event){return _vm.touchStart($event)},"touchmove":function($event){return _vm.touchMove($event)}}},[_c('navHeader',{attrs:{"moveUp":_vm.moveUp}}),_c('keep-alive',[_c('router-view')],1),(_vm.flag)?_c('navFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }